import vidyardEmbed from '@vidyard/embed-code';

let modal_toggles = document.querySelectorAll('[data-toggle-modal]');

modal_toggles.forEach(modal_toggle => {
    let modal = document.querySelector(modal_toggle.getAttribute('href') || modal_toggle.dataset.toggleModal);

    modal_toggle.addEventListener('click', e => {
        e.preventDefault();
        toggleModal(modal);
    });
});

function toggleModal(modal) {
    modal.classList.toggle('is-open');
    let vidyards = modal.querySelectorAll('[uuid]');

    vidyards.forEach(vidyard => {
        let uuid = vidyard.getAttribute('uuid');
        let player = vidyardEmbed.api.getPlayersByUUID(uuid);

        if (player[0]) {
            if (modal.classList.contains('is-open')) {
                player[0].play();
            } else {
                player[0].pause();
            }
        }
    })
}

if(typeof URLSearchParams !== 'undefined') {
    let url_params = new URLSearchParams(window.location.search);
    let autoplay_video = url_params.get('autoplay');

    if (autoplay_video) {
        window.addEventListener('load', () => {
            let modal = document.querySelector('#' + autoplay_video);
            toggleModal(modal);
        });
    }
}
